import { Outlet, useNavigate } from 'react-router-dom';
import { getCurrentUser, clearAuthData } from '@/services/api';
import Sidebar from './Sidebar';
import { Button } from '../ui/button';
import { LogOut } from 'lucide-react';
import { ThemeToggle } from '@/components/theme/ThemeToggle';
import NotificationBell from './NotificationBell';

export default function MainLayout() {
    const navigate = useNavigate();
    const user = getCurrentUser();

    const handleLogout = () => {
        clearAuthData();
        navigate('/login');
    };

    return (
        <div className="flex h-screen bg-background">
            <Sidebar />

            <div className="flex flex-1 flex-col overflow-hidden">
                {/* Header (terminal) */}
                <header className="flex h-16 shrink-0 items-center justify-between border-b border-border bg-background px-4 font-mono sm:px-6">
                    {/* Espaço para o botão hambúrguer no mobile */}
                    <h2 className="ml-12 text-sm font-medium tracking-tight text-foreground lg:ml-0">
                        Bem-vindo, {user?.name}
                    </h2>

                    <div className="flex items-center gap-2 sm:gap-3">
                        <NotificationBell />

                        <ThemeToggle />

                        <button
                            onClick={() => navigate('/profile')}
                            className="flex items-center gap-3 rounded-md px-2 py-1.5 transition-colors hover:bg-accent"
                        >
                            <div className="hidden text-right leading-tight sm:block">
                                <p className="text-sm font-medium text-foreground">{user?.name}</p>
                                <p className="text-[11px] text-muted-foreground">{user?.email}</p>
                            </div>
                            <div className="flex h-9 w-9 items-center justify-center rounded-md border border-border bg-card text-sm font-semibold text-foreground">
                                {user?.name?.charAt(0).toUpperCase()}
                            </div>
                        </button>

                        <Button
                            variant="ghost"
                            size="sm"
                            onClick={handleLogout}
                            className="hidden text-muted-foreground hover:text-foreground sm:flex"
                        >
                            <LogOut className="h-4 w-4" />
                        </Button>
                    </div>
                </header>

                {/* Main Content */}
                <main className="flex-1 overflow-y-auto p-4 sm:p-6">
                    <Outlet />
                </main>
            </div>
        </div>
    );
}